<template>
  <div class="player" @keydown="keyDown">
    <div class="player-top">
      <div class="video">
        <div class="video-back">
          <el-button
            @click="
              $router.push(
                `/video/videodetail?id=${$route.query.id}&clID=${$route.query.clID}`
              )
            "
            plain
            icon="ArrowLeftBold"
            >返回</el-button
          >
          <h3
            class="name ellipsis-1"
            v-for="iname in videoName"
            :key="iname.index"
          >
            {{ iname.name }}
          </h3>
        </div>
        <div id="app" class="video-player">
          <video ref="player" class="video-js">
            <source :src="urlsrc.url" type="video/mp4" />
          </video>
          <!-- <VideoLive /> -->
          <Transition name="slide-fade">
            <div v-show="loading" class="loading">
              <img src="../../../public/gif/loading.gif" alt="" />
            </div>
          </Transition>
        </div>
      </div>

      <div class="con">
        <el-tabs v-model="tabName" class="demo-tabs">
          <el-tab-pane label="试听目录" name="Catlog">
            <div class="content">
              <div class="con-one" v-for="vtem in videoList" :key="vtem.index">
                <div class="one" @click="changeShow(vtem)">
                  <i class="blue"></i>
                  <h4>{{ vtem.tvName }}</h4>
                  <i
                    v-if="!vtem.isShow"
                    style="font-size: 25px; color: #0a7fec"
                    class="iconfont icon-xiajiantou"
                  ></i>
                  <i
                    v-else
                    style="font-size: 25px"
                    class="iconfont icon-youjiantou"
                  ></i>
                </div>
                <Transition name="slide-fade">
                  <div class="tree" v-show="!vtem.isShow">
                    <div class="con-three" v-if="vtem.tvideos">
                      <ul
                        v-for="ltem in vtem.tvideos"
                        :key="ltem.index"
                        @click="switchVideo(ltem.tvideoId, ltem.tvideoVid)"
                      >
                        <a>
                          <li class="con-left" :title="ltem.tvideoName">
                            <span
                              :class="{
                                active: ltem.tvideoId == $route.query.tvideoId,
                              }"
                              >{{ ltem.tvideoName }}</span
                            >
                          </li>
                          <img
                            v-show="ltem.tvideoId == $route.query.tvideoId"
                            src="../../../public/icon/playing.gif"
                            alt=""
                          />
                        </a>
                      </ul>
                    </div>
                  </div>
                </Transition>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="课堂讲义" name="second"
            >试听课程暂无讲义、请联系客服老师了解课程详情</el-tab-pane
          >
        </el-tabs>
      </div>
    </div>
  </div>
  <div class="player-detail">
    <div class="player-desc">
      <ShTabs v-model="activeName">
        <ShTabsPanel label="课程目录" name="videoCatalog"
          ><VideoContent :videoData="videoData"
        /></ShTabsPanel>
        <ShTabsPanel label="课程详情" name="playDesc">
          <VideoImg :videoData="videoData" />
        </ShTabsPanel>
        <ShTabsPanel label="考试大纲" name="videoOutline"
          ><VideoOutline :videoData="videoData"
        /></ShTabsPanel>
        <ShTabsPanel label="讲师介绍" name="videoTeach"
          ><VideoTeacher :videoData="videoData"
        /></ShTabsPanel>
      </ShTabs>
    </div>
    <div class="player-reco">
      <VideoReCommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import "@/assets/styles/video-js.8.6.1.css";
import VideoContent from "../video-detail/compontents/video-content";
import VideoImg from "../video-detail/compontents/video-img.vue";
import VideoOutline from "../video-detail/compontents/video-outline.vue";
import VideoTeacher from "@/views/video-detail/compontents/video-teacher.vue";
import VideoReCommend from "@/components/video-recommend.vue";
import videojs from "video.js";
import { findVideoPlay, findVideoRecommand } from "@/api/video";
import { useRouter, useRoute } from "vue-router";
import { computed, ref, nextTick, reactive, onBeforeUnmount } from "vue";

import { ElMessage } from "element-plus";
export default {
  components: {
    VideoContent,
    VideoOutline,
    VideoImg,
    VideoTeacher,
    VideoReCommend,
  },
  setup() {
    const player = ref(null);
    const isPlaying = ref(false);
    let play;
    const activeName = ref("videoCatalog");
    const tabName = ref("Catlog");
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    //获取播放视频页面
    const videoData = ref([]);
    const videoList = ref([]);
    const urlsrc = reactive({
      url: "",
      type: "video/mp4",
    });
    //获取页面右侧视频推荐
    const VideoReCommend = ref([]);
    const clID = route.query.clID.split(",");
    findVideoRecommand(clID)
      .then((data) => {
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg: "/web/" + item.leImg,
            coverImg: "/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });

    //切换播放视频源
    const switchVideo = async (id, vid) => {
      console.log(id, vid);
      try {
        router.push(
          `videoplay?id=${route.query.id}&clID=${route.query.clID}&tvideoId=${id}`
        );
        urlsrc.src = vid;
        player.value.src = urlsrc.src;
        initPlay();
      } catch (error) {
        ElMessage.error(error.message);
      }
    };
    //点击展开目录
    const changeShow = (vtem) => {
      vtem.isShow = !vtem.isShow;
    };
    findVideoPlay(route.query.id).then((data) => {
      try {
        videoData.value = data;
        videoList.value = videoData.value[0]?.tvideo.map((item) => {
          return {
            tvID: item.tvID,
            tvName: item.tvName,
            tvideos: item.tvideos,
          };
        });

        //获取视频播放链接

        const getVod = getVideoList(videoData.value[0]?.tvideo);
        const list = getVod.find((item) => {
          return item.tvideoId == parseInt(route.query.tvideoId);
        });
        urlsrc.src = list.tvideoVid;
        nextTick(() => {
          initPlay();
        });
      } catch (error) {
        ElMessage.error(error.message);
      }
    });

    //循环视频播放链接
    function getVideoList(data) {
      try {
        let list = [];
        data.forEach((item) => {
          list.push(item);
          //console.log(item);
          if (item.tvideos) {
            list = list.concat(getVideoList(item.tvideos));
          }
        });
        return list;
      } catch (error) {
        console.log(error);
      }
    }
    //视频播放页面上方所属课程标题
    const videoName = computed(() => {
      return videoData.value.map((item) => {
        return {
          name: item.leName,
        };
      });
    });

    const handleVideoError = (error) => {
      console.log(error);
    };
    const handleVideoPlay = () => {
      try {
        loading.value = false;
        isPlaying.value = true;
      } catch (error) {
        console.log(error);
      }
    };
    const handleVideoPause = () => {
      try {
        isPlaying.value = false;
      } catch (error) {
        console.log(error);
      }
    };
    //初始化播放器
    const initPlay = async () => {
      await nextTick(() => {
        play = videojs(
          player.value,
          {
            language: "zh-CN",
            autoplay: true,
            controls: true,
            type: "video/mp4",
            width: 850,
            poster: "",
            playbackRates: [0.5, 1, 1.25, 1.5, 1.75, 2],
            sources: {
              type: "video/mp4",
              src: urlsrc.src,
            },
          },
          function onPlayerReady() {
            console.log("技术职称微信ngwenhe");
          }
        );
      });
      if (play) {
        play.on("play", handleVideoPlay);
        play.on("pause", handleVideoPause);
        play.on("error", handleVideoError);
        play.on("keydown", videoCtrl);
        play.on("ended", videoEnd);
      }

      // 监听加载开始
      if (play) {
        play.on("loadstart", () => {
          loading.value = true;
        });
      }
      // 监听加载完成
      if (play) {
        play.on("loadedmetadata", () => {
          loading.value = false;
        });
      }
      // 监听错误，可以在这里处理错误并隐藏加载动画
      if (play) {
        play.on("error", () => {
          loading.value = false;
        });
      }

      /* play.src = urlsrc.src;
      play.play(); */
    };
    //视频播放结束
    const videoEnd = () => {
      try {
        let list = [];
        videoData.value[0]?.tvideo.forEach((i) => {
          i.tvideos.forEach((j) => {
            list.push(j);
          });
        });
        let videoIndex = list.findIndex(
          (item) => item.tvideoId == parseInt(route.query.tvideoId)
        );
        videoIndex++;
        if (videoIndex >= list.length) {
          switchVideo(list[0]?.tvideoId, list[0]?.tvideoVid);
        } else {
          switchVideo(list[videoIndex].tvideoId, list[videoIndex].tvideoVid);
        }
      } catch (error) {
        console.log(error);
      }
    };
    //播放器键盘事件
    const videoCtrl = (event) => {
      if (event.key === "ArrowRight") {
        play.currentTime(play.currentTime() + 5);
      } else if (event.key === "ArrowLeft") {
        play.currentTime(Math.max(0, play.currentTime() - 5));
      } else if (event.keyCode === 32) {
        if (isPlaying.value) {
          play.pause();
        } else {
          play.play();
        }
      } else if (event.keyCode === 38) {
        play.volume(play.volume() + 0.1);
      } else if (event.keyCode === 40) {
        play.volume(play.volume() - 0.1);
      }
    };
    //阻止该页面的浏览器一些默认行为
    const keyDown = (event) => {
      if (
        event.keyCode === 32 ||
        event.keyCode === 37 ||
        event.keyCode === 38 ||
        event.keyCode === 39 ||
        event.keyCode === 40
      ) {
        event.preventDefault();
      }
    };
    //页面卸载时注销播放器
    onBeforeUnmount(() => {
      // 保存当前播放时间

      if (play) {
        play.dispose();
      }
    });

    return {
      activeName,
      VideoReCommend,
      videoData,
      VideoTeacher,
      urlsrc,
      switchVideo,
      player,
      tabName,
      videoList,
      videoName,
      loading,
      keyDown,
      changeShow,
    };
  },
};
</script>

<style lang="less" scoped>
.fade {
  &-leave {
    &-active {
      position: absolute;
      width: 100%;
      transition: opacity 0.2s 0.2s;
      z-index: 1;
    }
    &-to {
      opacity: 15%;
    }
  }
}
.video-js {
  width: 850px;
  height: 500px;
}
.player {
  width: 1240px;
  margin: 0 auto;
  .player-top {
    display: flex;
    background: rgb(245, 245, 245);
    justify-content: space-between;
    .video {
      height: 550px;
      .video-back {
        display: flex;
        align-items: center;
        height: 50px;
        width: 890px;
        h3 {
          margin-left: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .video-player {
        position: relative;
        .loading {
          position: absolute;

          top: 43%;
          left: 42%;
          img {
            width: 125px;
            height: 93.5px;
          }
        }
      }
    }
    .con {
      height: 550px;
      width: 350px;
      background: #fff;
      border-top: 1px solid #f5f5f5;
      .content {
        max-height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
        h3 {
          width: 350px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-bottom: 1px solid #f5f5f5;
        }
        .con-one {
          width: 100%;
          //height: 50px;
          cursor: pointer;
          .one {
            display: flex;
            height: 50px;
            align-items: center;
            border-bottom: 1px solid #f5f5f5;
            /* align-items: center; */

            .blue {
              display: inline-block;
              width: 3px;
              height: 20px;
              background: @shColor;
            }
            h4 {
              margin-left: 15px;
              width: 300px;
              line-height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .con-three {
            //height: 30px;
            ul {
              a {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 50px;
                //background: #f4f4f5;
                border-bottom: 1px solid #f5f5f5;
                border-right: 1px solid #f5f5f5;
                border-left: 1px solid #f5f5f5;
                &:hover {
                  //background: #f5f5f5;
                  color: @shColor;
                }
                .active {
                  color: #5bb8ff;
                }

                .con-left {
                  display: flex;
                  align-items: center;
                  margin-left: 20px;
                  margin-right: 8px;
                  margin-right: 18px;
                  font-size: 16px;

                  span {
                    display: inline-block;
                    width: 250px;
                    line-height: 30px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                img {
                  max-width: 24px;
                  max-height: 24px;
                  vertical-align: middle;
                  margin-right: 8px;
                }
              }
            }
          }
        }
      }
    }
    /* .video-con {
      width: 350px;
      height: 478.13px;
      margin-top: 50px;
      background: #fff;
      .con {
        margin: 5px 5px;

        ul {
          height: 420px;
          overflow: auto;
          li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 45px;
            p {
              font-size: 15px;
            }
            .active {
              color: #5bb8ff;
            }

            img {
              width: 20px;
              height: 20px;
              margin-right: 15px;
            }
            &:hover {
              cursor: pointer;
              color: @shColor;
            }
          }
        }
      }
    } */
  }
}
.player-detail {
  display: flex;
  justify-content: space-between;
  width: 1240px;
  margin: 25px auto;
  //height: 1000px;

  .player-desc {
    width: 850px;
    //height: 1000px;
    border-radius: 5px;
    background: #fff;
    .video-desc {
      display: flex;
      margin-top: 15px;
      justify-content: center;
    }
  }
  .player-reco {
    width: 350px;
    border-radius: 5px;
    background: #fff;
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.3, 0.5, 0.3, 0.5);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>

/* data() { return { activeName: "videoCatalog", vurl:
"https://mp4-auto-upload.cdn.bcebos.com/242/402/869e9aa025cc094d39d20aadac15385c.mp4",
feiyanurl:
"https://mp4-auto-upload.cdn.bcebos.com/45/284/dd285970d539323f94f42915d7bbf5bb.mp4",
manzufeiurl:
"https://mp4-auto-upload.cdn.bcebos.com/45/734/a5321e331644852afd71d250d54c00df.mp4",
xinneikeurl:
"https://mp4-auto-upload.cdn.bcebos.com/45/734/6dd3a0bb627efded69298e55bb8743de.mp4",
jichuurl:
"https://mp4-auto-upload.cdn.bcebos.com/45/2922/13084d8bfcd28ebe23ee135a8ec33f9c.mp4",
urlsrc:
"https://mp4-auto-upload.cdn.bcebos.com/45/284/dd285970d539323f94f42915d7bbf5bb.mp4",
type: "video/mp4", type: "rtmp/flv", }; }, methods: { switchVideoUrl(url) {
this.$refs.players.switchVideoUrl(url); }, }, created() { this.videoHeight();
},* /
